// import {jsExtend} from "../../imports";

export class BaseData {
    public error:string|null = null;

    // public static jsExtend(constructor:(...args:any[])=>any) {
    //    return jsExtend(constructor,BaseData);
    // }
}
